import { POSEIDON } from "../lib/defaults";
import { ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black border-t-4 border-[#F26522] mt-16" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white p-1">
              <img src={POSEIDON.logo} alt="Poseidon" className="w-full h-full object-contain" />
            </div>
            <div>
              <div className="font-heading text-lg font-black uppercase tracking-tight text-white">{POSEIDON.brand}</div>
              <a
                href={POSEIDON.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-xs text-[#F26522] hover:underline inline-flex items-center gap-1"
                data-testid="footer-website-link"
              >
                {POSEIDON.website} <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>
          <div className="text-xs font-mono text-white/40 uppercase tracking-wider">
            ProDose · © {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </footer>
  );
}
